<template>
	<span class="h-6 w-6 shrink-0 rounded-full hover:bg-red-50 text-red-600 cursor-pointer flex items-center justify-center dark:hover:bg-gray-800">
		<i class="fa-solid fa-times"/>
	</span>
</template>
<script setup lang="ts"></script>
